<template>
  <div class="question-add-paper">
    <div class="total">
      <div class="item" @click="onAnchor('base')">{{base.title}}</div>
      <div v-show="false"
        class="item"
        @click="onAnchor('section' + itemIndex)"
        v-for="(item, itemIndex) in sections"
        :key="itemIndex"
      >{{getSectionTitle(itemIndex)}}</div>
      <div class="item add-item" v-show="false" @click="addSection">+ 添加部分</div>
      <div class="info">
        <div class="count">
          <!-- <p class="ptitle">本试卷有{{sections.length}}部分共{{getQuesCountInPaper(-1)}}道题：</p> -->
          <p class="ptitle">本试卷共{{getQuesCountInPaper(-1)}}道题：</p>
          <div class="pitem">
            <p>{{getQuesCountInPaper(1)}}道单选题</p>
            <p>{{getQuesCountInPaper(2)}}道多选题</p>
          </div>
          <div class="pitem">
            <p>{{getQuesCountInPaper(3)}}道判断题</p>
            <p>{{getQuesCountInPaper(5)}}道简答题</p>
          </div>
        </div>
        <div class="score" style="display:none;">
          <p>总分{{getQuesScoreInPaper(-1)}}分</p>
          <div style="margin-top:5px;">
            通过分数
            <InputNumber
              v-model="base.form.pass_score"
              style="width:70px;margin-right:5px;"
              size="small"
              :min="0"
              :max="getQuesScoreInPaper(-1)"
            ></InputNumber>分
          </div>
        </div>
        <div class="time" style="display:none;">
          <p>总时长：</p>
          <RadioGroup v-model="base.limit_time_type">
            <Radio label="0">无限制</Radio>
            <Radio label="1">
              限制为
              <InputNumber
                v-model="base.form.limit_time"
                style="width:60px;margin-right:5px;"
                size="small"
                :min="1"
                :max="9999"
              ></InputNumber>分钟
            </Radio>
          </RadioGroup>
        </div>
        <div class="btn">
          <Button size="small" class="btn-margin-right" @click="onBack">返回</Button>
          <Button type="primary" size="small" @click="onSaveAndBack">保存并返回</Button>
        </div>
      </div>
    </div>
    <div class="paper">
      <div id="base" class="item">
        <div class="title">{{base.title}}</div>
        <Form ref="baseForm" :model="base.form" :rules="base.formRules" :label-width="80">
          <FormItem label="章节名称" prop="name">
            <Input v-model="base.form.name" placeholder="请输入试卷名称，最多不超过20个字" :maxlength="20"></Input>
          </FormItem>
          <FormItem label="排序" prop="sort">
            <Input
              v-model="base.form.sort"
              placeholder="请输入排序"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div
        :id="'section'+sectionIndex"
        class="item"
        v-for="(section, sectionIndex) in sections"
        :key="sectionIndex"
      >
        <div class="content">
          <div v-show="false" class="title">{{getSectionTitle(sectionIndex)}}</div>
          <div v-if="false" class="btn">
            <Button
              class="btn-margin-right"
              icon="md-arrow-round-up"
              @click="onMoveUpSection(sectionIndex)"
            >上移</Button>
            <Button
              class="btn-margin-right"
              icon="md-arrow-round-down"
              @click="onMoveDownSection(sectionIndex)"
            >下移</Button>
            <Button icon="md-trash" @click="onDeleteSection(sectionIndex)">移除该部分</Button>
          </div>
          <Form
            ref="sectionForm"
            :model="section.form"
            :rules="section.formRules"
            :label-width="110"
          >
            <FormItem v-show="false" :label="getSectionTitle(sectionIndex) + '名称'" prop="name">
              <Input
                v-model="section.form.name"
                placeholder="请输入试卷第一部分名称，最多不超过20个字"
                :maxlength="20"
              ></Input>
            </FormItem>
            <FormItem v-show="false" :label="getSectionTitle(sectionIndex) + '题目说明'" prop="introduce">
              <Input
                v-model="section.form.introduce"
                type="textarea"
                placeholder="请输入介绍，最多不超过300个字"
                :rows="4"
                :maxlength="300"
              ></Input>
            </FormItem>
          </Form>
          <Collapse value="1">
            <Panel name="1">
              试题信息
              <div class="info-box" slot="content">
                <p
                  class="info-desc"
                >该部分共有{{getQuesCountInSection(-1, section)}}道题，其中{{getQuesCountInSection(1, section)}}道单选题，{{getQuesCountInSection(2, section)}}道多选题，{{getQuesCountInSection(3, section)}}道判断题，{{getQuesCountInSection(5, section)}}道简答题</p>
                <Table :columns="sectionTotalColunms" :data="section.totalData" size="small">
                  <template
                    slot-scope="{row}"
                    slot="count"
                  >{{getQuesCountInSection(row.type, section)}}</template>
                  <template
                    slot-scope="{row}"
                    slot="score"
                  >{{getQuesScoreInSection(row.type, section)}}</template>
                  <template slot-scope="{row}" slot="action">
                    <Button type="text" @click="onDeleteQuesByType(sectionIndex, row.type)">移除</Button>
                  </template>
                </Table>
              </div>
            </Panel>
          </Collapse>
          <div class="question">
            <Collapse value="1">
              <Panel name="1">
                试题详情
                <div slot="content">
                  <div class="question-desc">
                    操作选中的{{section.selection.length}}道题目：
                    <Button
                      size="small"
                      icon="md-arrow-round-up"
                      class="btn-margin-right"
                      @click="onBatchMoveUpQues(section, sectionIndex)"
                    >上移</Button>
                    <Button
                      size="small"
                      icon="md-arrow-round-down"
                      class="btn-margin-right"
                      @click="onBatchMoveDownQues(section, sectionIndex)"
                    >下移</Button>
                    <Button
                      size="small"
                      icon="md-trash"
                      style="margin-right:20px;"
                      @click="onBatchDeleteQues(section)"
                    >移除</Button>
                    <span style="margin-right:20px;">总题数：{{getQuesCountInSection(-1, section)}}道</span>
                    <Button size="small" type="primary" @click="onAddQues(sectionIndex)">+选择试题</Button>
                  </div>
                  <Table
                    ref="questionTable"
                    class="question-table"
                    :columns="sectionQuesColunms"
                    :data="section.form.question"
                    :disabled-hover="true"
                    no-data-text="该部分下还没有试题，请点击 『选择试题』添加试题"
                    @on-selection-change="onSelectChangeQues($event, section)"
                  >
                    <template slot-scope="{row, index}" slot="ques">
                      <Collapse simple>
                        <Panel>
                          <span
                            style="margin-right:20px;"
                            class="ques-number"
                          >{{index+1}}、[{{getQuestionTypeName(row.ques_type)}}]</span>
                          <span style="margin-right:20px;">考点：{{row.point_name || '无'}}</span>
                          <span>更新于：{{row.updated_time}}</span>
                          <div class="ques-stem" v-html="row.ques_stem"></div>
                          <div slot="content">
                            <div class="option" v-if="row.ques_type == 1 || row.ques_type == 3">
                              <Radio
                                class="option-item"
                                :value="option.is_right == 1"
                                v-for="(option, optionIndex) in row.ques_option"
                                :key="optionIndex"
                                :disabled="true"
                              >
                                <div class="option-content" v-html="option.content"></div>
                              </Radio>
                            </div>
                            <div class="option" v-else-if="row.ques_type == 2">
                              <Checkbox
                                class="option-item"
                                :value="option.is_right == 1"
                                v-for="(option, optionIndex) in row.ques_option"
                                :key="optionIndex"
                                :disabled="true"
                              >
                                <div class="option-content" v-html="option.content"></div>
                              </Checkbox>
                            </div>
                            <div class="option-con" v-else-if="row.ques_type == 4">
                              <div class="option-con-left">
                                <div
                                  class="option-con-item"
                                  v-for="(option, optionIndex) in row.ques_option.left"
                                  :key="optionIndex"
                                >
                                  <div>
                                    <div
                                      style="display:inline-block; margin-right:5px;"
                                    >{{optionIndex + 1}})</div>
                                    <div class="connection" v-html="option.content"></div>
                                  </div>
                                  <div>
                                    答案：
                                    <Checkbox
                                      :value="option.is_right == rightItem.id"
                                      v-for="(rightItem, rightItemIndex) in row.ques_option.right"
                                      :key="rightItemIndex"
                                      :disabled="true"
                                    >{{getLetterNumber(rightItem.id)}}</Checkbox>
                                  </div>
                                </div>
                              </div>
                              <div class="option-con-right">
                                <div
                                  class="option-con-item"
                                  v-for="(option, optionIndex) in row.ques_option.right"
                                  :key="optionIndex"
                                >
                                  <div
                                    class="option-con-item-number"
                                  >选项{{getLetterNumber(option.id)}}</div>
                                  <div style="display:inline-block;" v-html="option.content"></div>
                                </div>
                              </div>
                            </div>
                            <div class="option" v-else>
                                <div class="rich-text" v-html="row.right_answer"></div>
                            </div>
                          </div>
                        </Panel>
                      </Collapse>
                    </template>
                    <template slot-scope="{index}" slot="score">
                      <InputNumber
                        v-model="section.form.question[index].score"
                        style="width:80px;margin-right:5px;"
                        size="small"
                        :min="0"
                        :max="9999"
                        @on-change="onQuesScoreChange(section, sectionIndex)"
                      ></InputNumber>分
                    </template>
                    <template slot-scope="{index}" slot="action">
                      <Button type="text" @click="onMergeQues(sectionIndex, index)">同步</Button>
                      -
                      <Button type="text" @click="onDeleteQues(sectionIndex, index)">移除</Button>
                    </template>
                  </Table>
                </div>
              </Panel>
            </Collapse>
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-model="chooseQuesModal.show"
      title="选择试题"
      @on-ok="onChooseQuesOk()"
      :width="900"
      class-name="vertical-center-modal"
      class="grid-select"
    >
      <Form :model="chooseQuesModal.form" :label-width="70" inline>
        <FormItem label="题库分类">
          <Cascader
            ref="chooseQuesBankClassify"
            :data="bankClassifySet"
            @on-change="onChangeChooseQuesBankClassify"
            trigger="hover"
            placeholder="全部题库分类"
            clearable
            style="width:200px;"
          ></Cascader>
        </FormItem>
        <FormItem label="试题类型">
          <Select
            v-model="chooseQuesModal.form.ques_type"
            clearable
            style="width:200px;"
            placeholder="全部题型"
          >
            <Option
              v-for="item in chooseQuesModal.quesTypeSet"
              :value="item.key"
              :key="item.key"
            >{{item.value}}</Option>
          </Select>
        </FormItem>
        <FormItem label="题库名称">
          <Input
            v-model="chooseQuesModal.form.bank"
            placeholder="请输入题库关键字"
            clearable
            style="width:200px;"
            @keydown.native.prevent.enter="onSearchChooseQues"
          ></Input>
        </FormItem>
      </Form>
      <Form :model="chooseQuesModal.form" :label-width="70" inline>
        <FormItem label="考点">
          <Cascader
            ref="chooseQuesPoint"
            :data="chooseQuesModal.pointSet"
            @on-change="onChangePoint"
            change-on-select
            trigger="click"
            placeholder="全部考点"
            clearable
            style="width:200px;"
          ></Cascader>
        </FormItem>
        <FormItem label="题干">
          <Input
            v-model="chooseQuesModal.form.ques_stem"
            placeholder="请输入题干关键字"
            clearable
            style="width:200px;"
            @keydown.native.prevent.enter="onSearchChooseQues"
          ></Input>
        </FormItem>
        <FormItem class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="onSearchChooseQues">搜索</Button>
            <Button icon="md-undo" @click="onResetChooseQues">重置</Button>
          </div>
        </FormItem>
      </Form>
      <Grid v-if="($route.query.type==0 || $route.query.chapter_id) && base.form.classify_id"
        ref="chooseQuesGrid"
        :columns="chooseQuesModal.colunms"
        :data-url="'/api/question/for/exam?bank_classify=' + base.form.classify_id"
        :search="chooseQuesModal.form"
        :rowsFormatter="onChooseQuesRowsFormatter"
        @onSelectionChange="onChooseQuesSelection"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="c1">
          <div class="rich-text" v-html="row.ques_stem"></div>
        </template>
      </Grid>
    </Modal>
    <Modal
      v-model="randomQuesModal.show"
      title="请选择题库"
      class-name="vertical-center-modal"
      :closable="false"
      :mask-closable="false"
      :width="1100"
      class="grid-select"
    >
      <Form :model="randomQuesModal.form" :label-width="70" inline>
        <FormItem label="题库分类">
          <Cascader
            ref="randomQuesBankClassify"
            :data="bankClassifySet"
            @on-change="onChangeRandomQuesBankClassify"
            trigger="hover"
            placeholder="全部题库分类"
            clearable
            style="width:200px;"
          ></Cascader>
        </FormItem>
        <FormItem label="题库名称">
          <Input
            v-model="randomQuesModal.form.name"
            placeholder="请输入题库关键字"
            clearable
            style="width:200px;"
            @keydown.native.prevent.enter="onSearchRandomQues"
          ></Input>
        </FormItem>
        <FormItem class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="onSearchRandomQues">搜索</Button>
            <Button icon="md-undo" @click="onResetRandomQues">重置</Button>
          </div>
        </FormItem>
      </Form>
      <Grid v-if="$route.query.type==1"
        ref="randomQuesGrid"
        :columns="randomQuesModal.colunms"
        data-url="/api/ques/bank/for/exam"
        :search="randomQuesModal.form"
        :rowsFormatter="onRandomQuesRowsFormatter"
        @onSelectionChange="onRandomQuesSelection"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="c5">
          <p>{{row.name}}</p>
          <p>({{row.single_choice + row.multi_choice + row.judge + row.connection}} / {{row.ques_amount}})</p>
        </template>
        <template slot-scope="{row,index}" slot="c1">
          <InputNumber
            v-model="randomQuesModal.list[index].single_choice"
            style="width:80px;margin-right:5px;"
            size="small"
            :min="0"
            :max="row.ques_single_amount"
            @on-change="onRandomQuesCountChange"
          ></InputNumber>
          <span>/ {{row.ques_single_amount}}</span>
        </template>
        <template slot-scope="{row,index}" slot="c2">
          <InputNumber
            v-model="randomQuesModal.list[index].multi_choice"
            style="width:80px;margin-right:5px;"
            size="small"
            :min="0"
            :max="row.ques_multi_amount"
            @on-change="onRandomQuesCountChange"
          ></InputNumber>
          <span>/ {{row.ques_multi_amount}}</span>
        </template>
        <template slot-scope="{row,index}" slot="c3">
          <InputNumber
            v-model="randomQuesModal.list[index].judge"
            style="width:80px;margin-right:5px;"
            size="small"
            :min="0"
            :max="row.ques_judge_amount"
            @on-change="onRandomQuesCountChange"
          ></InputNumber>
          <span>/ {{row.ques_judge_amount}}</span>
        </template>
        <template slot-scope="{row,index}" slot="c4">
          <InputNumber
            v-model="randomQuesModal.list[index].connection"
            style="width:80px;margin-right:5px;"
            size="small"
            :min="0"
            :max="row.ques_connect_amount"
            @on-change="onRandomQuesCountChange"
          ></InputNumber>
          <span>/ {{row.ques_connect_amount}}</span>
        </template>
        <template slot-scope="{row,index}" slot="c5">
          <InputNumber
            v-model="randomQuesModal.list[index].connection"
            style="width:80px;margin-right:5px;"
            size="small"
            :min="0"
            :max="row.ques_subject_amount"
            @on-change="onRandomQuesCountChange"
          ></InputNumber>
          <span>/ {{row.ques_connect_amount}}</span>
        </template>
      </Grid>
      <div slot="footer">
        <Button @click="$router.back()">返回</Button>
        <Button type="primary" @click="onRandomQuesOk()" :loading="randomQuesModal.btnLoading">抽取题目</Button>
      </div>
    </Modal>

    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import { QuestionType } from "@/utils/enums";

export default {
  name: "question-add-paper",
  mounted(){
    this.mathJax();
  },
  data() {
    return {
      bankClassifySet: [],
      spinShow: true,
      base: {
        title: "章节信息",
        limit_time_type: "0",
        classify: [],
        classify_value: [], //用于编辑试卷时候，初始化分类显示；新增试卷的时候没用
        form: {
          name: "",
          introduce: "",
          classify_id: "",
          limit_time: 0,
          pass_score: 0,
          type: -1,
          sort: 0
        },
        formRules: {
          name: [
            { required: true, message: "章节名称不能为空", trigger: "blur" }
          ],
          sort: [
            { required: true, message: "章节排序不能为空" }
          ]
        }
      },
      sections: [],
      sectionTitles: [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五",
        "十六",
        "十七",
        "十八",
        "十九",
        "二十"
      ],
      sectionTotalColunms: [
        { title: "题型", key: "name" },
        { title: "题目数", slot: "count", align: "center" },
        { title: "操作", slot: "action", align: "center", width: 150 }
      ],
      sectionQuesColunms: [
        { type: "selection", align: "left", width: 50 },
        { title: "题目", slot: "ques", minWidth: 400 },
        { title: "操作", slot: "action", align: "center", width: 100 }
      ],
      chooseQuesModal: {
        show: false,
        needRequest: true,
        quesTypeSet: QuestionType.getOptions(),
        pointSet: [],
        colunms: [
          { title: "题干", slot: "c1" },
          { title: "所属题库", key: "bank", align: "center", width: 150 },
          { title: "所属考点", key: "pointName", align: "center", width: 150 },
          {
            title: "题目类型",
            key: "quesTypeName",
            align: "center",
            width: 100
          }
        ],
        selection: [], //选取的试题ID
        sectionIndex: 0, //部分索引
        form: {
          bank_classify: "",
          ques_type: "",
          ques_stem: "",
          bank: "",
          point: "",
          init() {
            this.bank_classify = "";
            this.ques_type = "";
            this.ques_stem = "";
            this.bank = "";
            this.point = "";
          }
        }
      },
      randomQuesModal: {
        show: false,
        colunms: [
          { title: "题库", slot: "c5", align: "center" },
          { title: "题库分类", key: "classify", align: "center" },
          { title: "单选题", slot: "c1", align: "center" },
          { title: "多选题", slot: "c2", align: "center" },
          { title: "判断题", slot: "c3", align: "center" },
          { title: "连线题", slot: "c4", align: "center" },
          { title: "简答题", slot: "c5", align: "center" }
        ],
        selection: [], //选取的题库对象
        list: [],
        btnLoading: false,
        form: {
          bank_classify: "",
          name: "",
          init() {
            this.bank_classify = "";
            this.name = "";
          }
        }
      }
    };
  },
  async created() {
  //  await this.requestPaperClassify();
    await this.requestBankClassify();
    await this.requestChapter();
    this.initData();
  },
  methods: {
    mathJax() {
      let _this = this;
      if (this.MathJax.isMathjaxConfig) { // 判断是否初始配置，若无则配置。
          this.MathJax.initMathjaxConfig()
      }
      setTimeout(function(){
        _this.MathJax.MathQueue()// 传入组件id，让组件被MathJax渲染
        _this.spinShow = false;
      },2000)
    },
    requestChapter() {
      this.$http
        .get(`/api/exam/exercise-chapter/${this.$route.query.chapter_id}`)
        .then(data => {
            this.base.form.classify_id = data.classify_id;
        });
    },
    // on event
    onAnchor(eleID) {
      document.getElementById(eleID).scrollIntoView({
        behavior: "smooth"
      });
    },
    onMoveUpSection(sectionIndex) {
      if (sectionIndex <= 0) {
        return;
      }
      this.$pub.swapArrayItem(this.sections, sectionIndex, sectionIndex - 1);
      this.$nextTick(() => {
        this.onAnchor("section" + (sectionIndex - 1));
      });
    },
    onMoveDownSection(sectionIndex) {
      if (sectionIndex >= this.sections.length - 1) {
        return;
      }
      this.$pub.swapArrayItem(this.sections, sectionIndex, sectionIndex + 1);
      this.$nextTick(() => {
        this.onAnchor("section" + (sectionIndex + 1));
      });
    },
    onDeleteSection(sectionIndex) {
      if (this.sections.length <= 1) {
        this.$Message.info("至少需要保留一个部分");
        return;
      }
      this.$Modal.confirm({
        title: "提示",
        content: `是否移除 <${this.getSectionTitle(sectionIndex)}> ？`,
        onOk: () => {
          this.sections.splice(sectionIndex, 1);
        }
      });
    },
    onDeleteQuesByType(sectionIndex, quesType) {
      const section = this.sections[sectionIndex];
      if (!this.getQuesCountInSection(quesType, section)) {
        this.$Message.info("当前部分没有试题可移除");
        return;
      }
      this.$Modal.confirm({
        title: "提示",
        content: `是否移除 <${this.getSectionTitle(
          sectionIndex
        )}> 所有 <${QuestionType.getValue(quesType)}> ？`,
        onOk: () => {
          const queses = section.form.question;
          for (let i = queses.length - 1; i >= 0; --i) {
            if (queses[i].ques_type == quesType) {
              queses.splice(i, 1);
            }
          }
        }
      });
    },
    onOpenBatchSetScoreQues(section) {
      if (section.selection.length <= 0) {
        this.$Message.info("请先选择试题");
        return;
      }
      section.showBatchScore = !section.showBatchScore;
    },
    onBatchSetScoreQues(section) {
      section.form.question.forEach(i => {
        if (section.selection.includes(i.id)) {
          i.score = section.batchScore;
        }
      });
      // end todo...
      section.showBatchScore = false;
      section.batchScore = 0;
      // not keep selected
      this.noKeepSelected(section);
    },
    onBatchMoveUpQues(section, sectionIndex) {
      if (section.selection.length <= 0) {
        this.$Message.info("请先选择试题");
        return;
      }
      const selectionIndex = [];
      section.selection.forEach(i => {
        section.form.question.forEach((ci, index) => {
          if (ci.id == i) {
            selectionIndex.push(index);
          }
        });
      });
      selectionIndex.forEach(i => {
        if (
          i <= 0 ||
          section.selection.includes(section.form.question[i - 1].id)
        )
          return;
        this.$pub.swapArrayItem(section.form.question, i, i - 1);
      });
      // keep selected
      this.keepSelected(section, sectionIndex);
    },
    onBatchMoveDownQues(section, sectionIndex) {
      if (section.selection.length <= 0) {
        this.$Message.info("请先选择试题");
        return;
      }
      const selectionIndex = [];
      section.selection.forEach(i => {
        section.form.question.forEach((ci, index) => {
          if (ci.id == i) {
            selectionIndex.push(index);
          }
        });
      });
      selectionIndex.reverse();
      selectionIndex.forEach(i => {
        if (
          i >= section.form.question.length - 1 ||
          section.selection.includes(section.form.question[i + 1].id)
        )
          return;
        this.$pub.swapArrayItem(section.form.question, i, i + 1);
      });
      // keep selected
      this.keepSelected(section, sectionIndex);
    },
    onBatchDeleteQues(section) {
      if (section.selection.length <= 0) {
        this.$Message.info("请先选择试题");
        return;
      }
      this.$Modal.confirm({
        title: "提示",
        content: "是否移除选中试题？",
        onOk: () => {
          const queses = section.form.question;
          for (let i = queses.length - 1; i >= 0; --i) {
            if (section.selection.includes(queses[i].id)) {
              queses.splice(i, 1);
            }
          }
          // not keep selected
          this.noKeepSelected(section);
        }
      });
    },
    onAddQues(sectionIndex) {
      this.initModalFilter();
      this.chooseQuesModal.show = true;
      this.chooseQuesModal.sectionIndex = sectionIndex;
      this.chooseQuesModal.selection = [];
      // clear grid selection
      this.$refs.chooseQuesGrid.recoverSelectedItems([]);
    },
    onQuesScoreChange(section, sectionIndex) {
      this.keepSelected(section, sectionIndex);
    },
    onSelectChangeQues(selection, section) {
      section.selection = [];
      selection.forEach(i => {
        section.selection.push(i.id);
      });
    },
    onDeleteQues(sectionIndex, index) {
      this.$Modal.confirm({
        title: "提示",
        content: "是否移除该试题？",
        onOk: () => {
          this.sections[sectionIndex].form.question.splice(index, 1);
        }
      });
    },

    onMergeQues(sectionIndex, index) {
      this.$Modal.confirm({
        title: "提示",
        content: "是否同步题库中的试题？",
        onOk: () => {
          let question = this.sections[sectionIndex].form.question[index];

          this.$http.post("/api/question/merge", {
            package_id: this.package_id,
            question_id: question.id,
            type: 'exercise'
          }).then((data) => {
                this.$Message.success("操作成功");
          });
        }
      });
    },

    onChooseQuesOk() {
      if (this.chooseQuesModal.selection.length == 0) {
        this.$Message.info("未选择任何试题");
        return;
      }
      this.$http
        .post("/api/exam/extract", {
          type: 0, // 这里固定传手工卷类型
          question_id: this.chooseQuesModal.selection.join()
        })
        .then(data => {
          // fitler same id question
          const questions = [];
          let foundSame = false;
          data.forEach(i => {
            let found = false;
            for (const section of this.sections) {
              for (const ques of section.form.question) {
                if (ques.id == i.id) {
                  foundSame = true;
                  found = true;
                  break;
                }
              }
              if (found) break;
            }
            if (!found) {
              questions.push(i);
            }
          });
          // push qustion
          questions.forEach(i => {
            i.updated_time = this.$pub.timestampToTime(i.updated_at);
            i.score = i.score ? +i.score : 0;
            this.sections[this.chooseQuesModal.sectionIndex].form.question.push(
              i
            );
          });
          if (foundSame) {
            this.$Message.info("发现相同试题，已为您过滤");
          }
          if (questions.length > 0) {
            this.$Message.info("添加试题成功");
          }
        });
        let _this = this;
        setTimeout(function(){
          _this.mathJax();
        },100)
    },
    onRandomQuesOk() {
      // 是否选了题库
      if (this.randomQuesModal.selection.length == 0) {
        this.$Message.info("请先选择题库");
        return false;
      }
      /** 由于 iview 的 selection 只是 list 的一份拷贝
       * 所以 selection 中的试题数量并不会被双向绑定，故这里重新从 list 中组合新的 selection */
      const selection = [];
      this.randomQuesModal.selection.forEach(i => {
        for (const listItem of this.randomQuesModal.list) {
          if (listItem.id == i.id) {
            selection.push(listItem);
            break;
          }
        }
      });
      // 是否有试题数量
      let quesCount = 0;
      selection.forEach(i => {
        quesCount += i.single_choice;
        quesCount += i.multi_choice;
        quesCount += i.judge;
        quesCount += i.connection;
      });
      if (quesCount == 0) {
        this.$Message.info("题目数量不能为0");
        return;
      }
      // 开始处理
      this.randomQuesModal.btnLoading = true;
      const checkOption = [];
      selection.forEach(i => {
        checkOption.push({
          bank_id: i.id,
          single_choice: i.single_choice,
          multi_choice: i.multi_choice,
          judge: i.judge,
          connection: i.connection
        });
      });
      this.$http
        .post("/api/exam/extract", {
          type: this.base.form.type,
          check_option: JSON.stringify(checkOption)
        })
        .then(data => {
          // classify
          const questionClassifySet = {};
          data.question.forEach(i => {
            if (questionClassifySet[i.ques_type]) {
              questionClassifySet[i.ques_type].push(i);
            } else {
              questionClassifySet[i.ques_type] = [i];
            }
          });
          // add section & push question
          for (const i in questionClassifySet) {
            const newSection = this.addSection();
            newSection.form.name = QuestionType.getValue(i);
            questionClassifySet[i].forEach(ques => {
              ques.updated_time = this.$pub.timestampToTime(ques.updated_at);
              ques.score = ques.score ? +ques.score : 0;
              newSection.form.question.push(ques);
            });
          }
          // end todo...
          this.randomQuesModal.btnLoading = false;
          this.randomQuesModal.show = false;
        });
        let _this = this;
        setTimeout(function(){
          _this.mathJax();
        },200)
    },
    onChangePaperClassify(val) {
      this.base.form.classify_id = val.pop();
    },
    onChangeChooseQuesBankClassify(val) {
      this.chooseQuesModal.form.bank_classify = val.pop();
    },
    onChangePoint(val) {
      this.chooseQuesModal.form.point = val.pop();
    },
    onSearchChooseQues() {
      this.$refs.chooseQuesGrid.searchRefresh();
    },
    onResetChooseQues() {
      this.chooseQuesModal.form.init();
      this.$refs.chooseQuesBankClassify.clearSelect();
      this.$refs.chooseQuesPoint.clearSelect();
      this.onSearchChooseQues();
    },
    onBack() {
      this.$Modal.confirm({
        title: "提示",
        content: "未保存的内容将会丢失，确定返回吗？",
        onOk: () => {
          this.$router.back();
        }
      });
    },
    async onSaveAndBack() {
      // validate
      let hasError = false;
      if (!(await this.$refs.baseForm.validate())) {
        hasError = true;
      } else {
        // for (const form of this.$refs.sectionForm) {
        //   if (!(await form.validate())) {
        //     hasError = true;
        //     break;
        //   }
        // }
      }
      if (hasError) {
        this.$Message.error("请先完善必填项");
        return;
      }
      if (this.base.limit_time_type == 1 && this.base.form.limit_time <= 0) {
        this.$Message.error("总时长限制至少为1分钟");
        return;
      }
      // make request data
      const params = {
        name: this.base.form.name,
        introduce: this.base.form.name,
        classify_id: this.base.form.classify_id,
        limit_time: this.base.form.limit_time,
        score: this.getQuesScoreInPaper(-1),
        pass_score: this.base.form.pass_score,
        type: this.base.form.type
      };
      if (this.base.limit_time_type == 0) {
        // 总时长无限制，则传 -1
        params.limit_time = -1;
      }
      const section = [];
      this.sections.forEach((i, sectionIndex) => {
        const questions = [];
        i.form.question.forEach((ci, quesIndex) => {
          questions.push({
            ques_id: ci.id,
            score: ci.score,
            bank_id: ci.bank_id,
            type: ci.ques_type,
            sort: quesIndex
          });
        });
        const sectionObj = {
          name: '第一部分',
          introduce: '',
          score: this.getQuesScoreInSection(-1, i),
          sort: sectionIndex,
          section_detail: questions
        };
        if (i.id) {
          sectionObj.id = i.id;
        }
        section.push(sectionObj);
      });
      params.section = JSON.stringify(section);
      params.is_show = 0;
      switch (this.$route.name) {
        case "QuestionExerciseChapterPeriodCreate":
          this.$http.post("/api/exam/add", params).then((data) => {
            let periodParam = {
              title: this.base.form.name,
              parent_id: this.$route.query.chapter_id,
              sort: this.base.form.sort,
              exam_id: data.id
            }
            this.$http.post("/api/exam/exercise-period", periodParam).then(() => {
                this.$Message.success("新增试卷成功");
                this.$router.back();
            });
          });
          break;
        case "QuestionExerciseChapterPeriodEdit":
            this.$http
              .put(`/api/exam/edit/${this.exam_id}`, params)
              .then(() => {
                let periodParam = {
                  id: this.$route.query.id,
                  title: this.base.form.name,
                  sort: this.base.form.sort
                }
                this.$http.put(`/api/exam/exercise-period/${this.$route.query.id}`, periodParam).then(() => {
                  this.$Message.success("编辑试卷成功");
                  this.$router.back();
              });
          });
          break;
      }
    },
    onChooseQuesRowsFormatter(rows) {
      rows.forEach(i => {
        i.pointName = i.point || "无";
        i.quesTypeName = QuestionType.getValue(i.ques_type);
      });
    },
    onChooseQuesSelection(items) {
      this.chooseQuesModal.selection = [];
      items.forEach(i => {
        this.chooseQuesModal.selection.push(i.id);
      });
    },
    onChangeRandomQuesBankClassify(val) {
      this.randomQuesModal.form.bank_classify = val.pop();
    },
    onRandomQuesRowsFormatter(rows) {
      rows.forEach(i => {
        i.single_choice = 0;
        i.multi_choice = 0;
        i.judge = 0;
        i.connection = 0;
      });
      this.randomQuesModal.list = rows;
    },
    onRandomQuesSelection(items) {
      this.randomQuesModal.selection = items;
    },
    onSearchRandomQues() {
      this.$refs.randomQuesGrid.searchRefresh();
    },
    onResetRandomQues() {
      this.randomQuesModal.form.init();
      this.$refs.randomQuesBankClassify.clearSelect();
      this.onSearchRandomQues();
    },
    onRandomQuesCountChange() {
      this.$refs.randomQuesGrid.recoverSelectedItems(
        this.randomQuesModal.selection
      );
    },
    // other
    initData() {
      switch (this.$route.name) {
        case "QuestionExerciseChapterPeriodCreate":
          {
            this.base.form.type = 0;
            this.addSection();
          }
          break;
        case "QuestionExerciseChapterPeriodEdit":
          {
            this.$http
              .get(`/api/exam/exercise-period/${this.$route.query.id}`)
              .then(data => {
                  this.exercise_id = data.exercise_id;
                  this.exam_id = data.chapter_exam.exam_id;
                  this.package_id = data.chapter_exam.id;
                  this.base.form.sort = data.sort;
                  this.base.form.title = data.title;
                  this.$http
                    .get(`/api/exam/edit/detail/${this.exam_id}`)
                    .then(data => {
                      //-- base
                      Object.assign(this.base.form, data.exam_base);
                      this.base.form.pass_score = +this.base.form.pass_score;
                      if (this.base.form.limit_time < 0) {
                        this.base.limit_time_type = "0";
                        this.base.form.limit_time = 0;
                      } else {
                        this.base.limit_time_type = "1";
                      }
                      //-- section
                      data.exam_section.forEach(i => {
                        const section = this.addSection();
                        section.form.id = i.id;
                        section.form.name = '第一部分';
                        section.form.introduce = '';
                        section.form.question = i.question;
                        section.form.question.forEach(ci => {
                          ci.updated_time = this.$pub.timestampToTime(ci.updated_at);
                          ci.score = ci.score ? +ci.score : 0;
                        });
                      });
                    });
              });
          }
          break;
      }
    },
    initModalFilter() {
      if (!this.chooseQuesModal.needRequest) return;
      this.chooseQuesModal.needRequest = false;
      // point
      this.$http.get("/api/exam/point").then(data => {
        function recursionSetChild(item) {
          item.value = item.id;
          item.label = item.name;
          if (item.child) {
            item.children = item.child;
            item.children.forEach(ci => {
              recursionSetChild(ci);
            });
          }
        }
        data.forEach(i => {
          recursionSetChild(i);
        });
        this.chooseQuesModal.pointSet = data;
      });
    },
    addSection() {
      if (this.sections.length >= this.sectionTitles.length - 1) {
        this.$Message.info("试卷部分数量已达上限");
        return;
      }
      this.sections.push({
        showBatchScore: false, //是否显示批量设置分值
        batchScore: 0, //批量设置分值
        selection: [], //选中的试题，可多个
        totalData: [
          { name: "单选题", type: 1 },
          { name: "多选题", type: 2 },
          { name: "判断题", type: 3 },
          { name: "简答题", type: 5 }
        ],
        form: {
          name: "",
          introduce: "",
          question: []
        },
        formRules: {
          name: [{ required: true, message: "名称不能为空", trigger: "blur" }]
        }
      });
      return this.sections[this.sections.length - 1];
    },
    getSectionTitle(index) {
      return `第${this.sectionTitles[index + 1]}部分`;
    },
    getQuestionTypeName(type) {
      return QuestionType.getValue(type);
    },
    // 获取字母序号 number >= 1
    getLetterNumber(number) {
      return String.fromCharCode(64 + number);
    },
    // 获取section内题目数量，quesType传-1 表示全部数量
    getQuesCountInSection(quesType, section) {
      let ret = 0;
      section.form &&
        section.form.question &&
        section.form.question.forEach(i => {
          if (quesType == -1 || quesType == i.ques_type) ++ret;
        });
      return ret;
    },
    // 获取section内题目分值，quesType传-1 表示全部分值
    getQuesScoreInSection(quesType, section) {
      let ret = 0;
      section.form &&
        section.form.question &&
        section.form.question.forEach(i => {
          if (quesType == -1 || quesType == i.ques_type) ret += i.score;
        });
      return ret;
    },
    // 获取整张试卷的题目数量
    getQuesCountInPaper(quesType) {
      let ret = 0;
      this.sections.forEach(i => {
        ret += this.getQuesCountInSection(quesType, i);
      });
      return ret;
    },
    // 获取整张试卷的分值
    getQuesScoreInPaper(quesType) {
      let ret = 0;
      this.sections.forEach(i => {
        ret += this.getQuesScoreInSection(quesType, i);
      });
      return ret;
    },
    keepSelected(section, sectionIndex) {
      this.$nextTick(() => {
        const rows = this.$refs.questionTable[sectionIndex].objData;
        for (const key in rows) {
          const row = rows[key];
          row._isChecked = section.selection.includes(row.id);
        }
      });
    },
    noKeepSelected(section) {
      section.selection = [];
    },
    // request
    async requestPaperClassify() {
      const data = await this.$http.get("/api/exam/classify");
      for (let i = data.length - 1; i >= 0; --i) {
        if (!data[i].children || !data[i].children.length) {
          data.splice(i, 1);
        }
      }
      this.base.classify = data;
    },
    async requestBankClassify() {
      const data = await this.$http.get("/api/course/classify");
      data.forEach(i => {
        i.value = i.id;
        i.label = i.name;
        if (i.child) {
          i.children = i.child;
          i.children.forEach(ci => {
            ci.value = ci.id;
            ci.label = ci.name;
          });
        } else {
          i.disabled = true;
        }
      });
      this.bankClassifySet = data;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";
.question-add-paper {
  .total {
    position: fixed;
    width: 220px;
    border: 1px solid rgba(45, 140, 240, 0.5);
    border-radius: 4px;
    padding: 4px;
    .item {
      height: 30px;
      line-height: 30px;
      background-color: #ccc;
      margin-bottom: 5px;
      text-align: center;
      font-weight: 500;
      border-radius: 4px;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .add-item {
      background-color: $primary_color;
      color: #fff;
    }
    .info {
      padding: 0 5px;
      margin-top: 10px;
      .count {
        .pitem {
          display: flex;
          justify-content: space-around;
        }
      }
      .score {
        margin-top: 10px;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
      }
      .time {
        margin-top: 10px;
        padding-top: 10px;
        display: flex;
        justify-content: space-between;
        // align-items: center;
        border-top: 1px solid #eee;
        .ivu-radio-wrapper {
          margin-right: 0;
        }
        p {
          width: 100%;
        }
      }
      .btn {
        margin-top: 20px;
        text-align: center;
      }
    }
  }
  .paper {
    margin-left: 230px;
    max-width: 1200px;
    min-width: 700px;
    .item {
      background-color: #f5f5f5;
      border: 1px solid #ccc;
      border-radius: 5px;
      padding: 10px 20px;
      margin-bottom: 20px;
      .content {
        position: relative;
        .btn {
          position: absolute;
          top: 10px;
          right: 20px;
        }
        .info-box {
          .info-desc {
            color: #888;
            margin-bottom: 10px;
          }
        }
        .question {
          margin-top: 10px;
          .question-table {
            margin-top: 10px;
            /deep/ .ivu-collapse-simple {
              border: none;
            }
            /deep/ .ivu-collapse-header {
              height: auto;
              line-height: 16px;
              margin: 10px 0;
              padding-left: 0;
            }
            /deep/ .ivu-collapse-content {
              padding-left: 0;
            }
            /deep/ .ivu-collapse-header .ivu-icon-ios-arrow-forward::before {
              content: "";
              display: block;
              background: url("~@/assets/images/icon-collapse.png") no-repeat
                center;
              background-size: 10px 10px;
              width: 10px;
              height: 10px;
            }
            /deep/
              .ivu-collapse
              > .ivu-collapse-item.ivu-collapse-item-active
              > .ivu-collapse-header
              > i {
              transform: rotate(180deg);
            }
            .ques-number {
              color: $primary_color;
            }
            .ques-stem {
              // text-indent: 2em;
              font-weight: 500;
              margin-top: 10px;
            }
            .option {
              display: flex;
              flex-direction: column;
              .option-item {
                margin-bottom: 10px;
                &:last-child {
                  margin-bottom: 0;
                }
                .option-content {
                  display: inline-block;
                }
              }
            }
            .option-con {
              display: flex;
              .option-con-left {
                padding-right: 15px;
                border-right: 1px solid #eee;
              }
              .option-con-right {
                padding-left: 15px;
              }
              .option-con-item {
                width: 270px;
                border: 1px solid #ddd;
                border-radius: 5px;
                margin-bottom: 10px;
                padding: 5px;
                &:last-child {
                  margin-bottom: 0;
                }
                .option-con-item-number {
                  width: 50px;
                  height: 20px;
                  background-color: rgba(45, 140, 240, 0.8);
                  border-radius: 3px;
                  color: #fff;
                  line-height: 20px;
                  text-align: center;
                  display: inline-block;
                  margin-right: 10px;
                }
                .connection {
                  display: inline;
                  /deep/ p {
                    display: inline;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.ivu-select-item {
  margin: 0;
  padding: 7px 16px;
}
// /deep/ .ivu-modal {
//   height: calc(100vh - 80px);
// }
</style>
